export default {
  listTitleTable: {
    Symbol: 'Mã',
    TotalQuantity: 'Tổng KL',
    CostPrice: 'Giá vốn',
    MarketPrice: 'Giá hiện tại',
    InitialValue: 'Giá trị vốn',
    StockValue: 'Giá trị thị trường',
    UnrealizedProfit: 'Lãi / lỗ',
  },
  buttonTitle: {
    Reload: 'Tải lại',
  },
  title: {
    TotalCost: 'Tổng giá trị vốn',
    TotalUnrealizedProfit: 'Tổng Lãi/Lỗ',
  },
  listPopupTitle: {
    TradeQuantity: 'Được GD',
    BlockedQuantity: 'Phong tỏa',
    ReceivingRightQuantity: 'Quyền chờ',
    ReceivingQuantity: 'Chờ về',
    ReceivingT0Quantity: 'T0',
    ReceivingT1Quantity: 'T1',
    ReceivingT2Quantity: 'T2',
  },
  Table: {
    TABLE_FOOTER_TEXT_WITH_UNIT:
      'Dữ liệu danh mục hiện thị tại FiinTrade được cung cấp bởi DNSE. Dữ liệu tính toán có thể khác với dữ liệu hiển thị trên https://entradex.dnse.com.vn/ do phương pháp tính khác nhau.',
  },
};
